import { Injectable } from '@angular/core';
import { TextChat } from '../xislivechat/models/text-chat';
import { BcRestApi } from '../api/rest-api';
import { Observable } from 'rxjs';
import { DynamicQueryEvent } from 'common/dynamicquery/dynamic-query-events.factory';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';
import { AssignmentHistoryModel } from 'shared/components/assignment-history/models/assignment-history.model';
import { DynamicQueryObservable } from 'common/dynamicquery/dynamic-query-observable.model';

@Injectable()
export class TextChatsService {

  constructor(private dynamicQuery: DynamicQueryAdapterService,
              private dynamicQueryDecorator: DynamicQueryDecoratorService,
              private bcRestApi: BcRestApi) {
  }

  observeActiveTextChatsByFolder(folderId): DynamicQueryObservable<TextChat> {
    if (!folderId) {
      throw new Error('Missing folderId');
    }
    const activeTextChatsObservable = this.dynamicQuery.getQuery('activeTextChatsByFolderID', { FolderID: folderId });
    return this.dynamicQueryDecorator.create(activeTextChatsObservable, TextChat.wrap);
  }

  observeTextChatByTextChatId(textChatId): Observable<DynamicQueryEvent> {
    if (!textChatId) {
      throw new Error('Missing textChatId');
    }
    const textChatObs = this.dynamicQuery.getQuery('textChatByTextChatID', { TextChatID: textChatId });
    return this.dynamicQueryDecorator.create(textChatObs, TextChat.wrap);
  }

  answerTextChat(textChatId): any {
    return this.bcRestApi.answerTextChat(textChatId);
  }

  endTextChat(textChatId) {
    return this.bcRestApi.endTextChat(textChatId);
  }

  public getAssignmentHistoryByTextChatId(textChatId: string): Promise<AssignmentHistoryModel[]> {
    return this.bcRestApi.getAssignmentHistoryByTextChatId(textChatId);
  }
}
